export const DRAG_DROP_RELEASED_OUTSIDE_EVENT = 'released-outside';

export const DRAG_TRIGGER_REGISTERED_EVENT = 'trigger-registered';
